"use client";

import { ToastProvider } from "@/contexts/toast-context";

export function MarketingProviders({ children }: { children: React.ReactNode }) {
  return <ToastProvider>{children}</ToastProvider>;
}
